// Purpose: Constants for the customer service.
export const paths= {
    ONBOARDING_MIDDLEWARE_GET_CLIENTS: "/onboardingmiddleware/GetClients",
}